var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-signup-info" },
    [
      _c("div", { staticClass: "fs16 fw500 c-cC26 mb24" }, [
        _vm._v(_vm._s(_vm.language().tit_applicant)),
      ]),
      _c("div", { staticClass: "mb24 h22" }, [
        _c("div", { staticClass: "fs14 c-cC8C pull-left w50p-12" }, [
          _vm._v("\n      " + _vm._s(_vm.language().lbl_name) + "：\n      "),
          _c(
            "span",
            { staticClass: "c-cC26" },
            [
              _c("yxtbiz-user-name", {
                attrs: { name: _vm.data.fullname || "--" },
              }),
              _vm._v("（" + _vm._s(_vm.data.username || "--") + "）\n      "),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "fs14 c-cC8C pull-right w50p-12" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.language().lbl_department) + "：\n      "
          ),
          _c(
            "span",
            { staticClass: "c-cC26" },
            [
              _c("yxtbiz-dept-name", {
                attrs: { name: _vm.data.deptName || "--" },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "mb36 h22" }, [
        _c("div", { staticClass: "fs14 c-cC8C pull-left w50p-12" }, [
          _vm._v(_vm._s(_vm.language().lbl_position_name) + "："),
          _c(
            "span",
            { staticClass: "c-cC26" },
            [
              _c("yxtbiz-position-name", {
                attrs: { name: _vm.data.positionNameList || "--" },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm.data.surveyProjectAnswerUrl
        ? [
            _c("div", { staticClass: "fs16 fw500 c-cC26 mb24" }, [
              _vm._v(_vm._s(_vm.language().tit_check)),
            ]),
            _c("div", { staticClass: "fs14 mb36" }, [
              _c(
                "div",
                {
                  staticClass: "relative h40 pl40 bc-cCF5 rtl4 rtr4 rbl4 rbr4",
                },
                [
                  _c("img", {
                    staticClass: "absolute wh24 left12 top8",
                    attrs: {
                      src:
                        _vm.$staticBaseUrl +
                        "assets/862f0624/fba17c0a/investigate.svg",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "c-cC26 ellipsis w148-max inline-block relative top9",
                    },
                    [_vm._v(_vm._s(_vm.data.surveyTemplateName))]
                  ),
                  _c(
                    "yxt-button",
                    {
                      staticClass: "pull-right relative top8 right12",
                      attrs: { size: "small", plain: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toSurvey.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.language().btn_see_check))]
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
      _vm.data.attachments && _vm.data.attachments.length
        ? [
            _c("div", { staticClass: "fs16 fw500 c-cC26 mb24" }, [
              _vm._v(_vm._s(_vm.language().tit_attach)),
            ]),
            _c(
              "div",
              { staticClass: "fs14 mb36" },
              _vm._l(_vm.data.attachments, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class:
                      "inline-block " +
                      (index % 2 === 0 ? "" : "ml24") +
                      " border-box relative mb4 w50p-12 h40 pl40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4",
                    on: {
                      click: function ($event) {
                        return _vm.downloadFunc(item)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "absolute wh20 left14 top10",
                      attrs: { src: _vm.getIconName(item.fileClass) },
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-cC26 ellipsis w148-max inline-block relative top9",
                        attrs: {
                          title: item.name && item.name.replace(/\.[^.]+$/, ""),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(item.name && item.name.replace(/\.[^.]+$/, ""))
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      { staticClass: "c-cC26 inline-block relative top3" },
                      [
                        _vm._v(
                          "." + _vm._s(item.name && item.name.split(".").pop())
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      { staticClass: "c-cC8C fs12 ml8 relative top2" },
                      [_vm._v(_vm._s(_vm.getSize(item.size)))]
                    ),
                    _c("img", {
                      staticClass:
                        "x-close c-cC26-hover c-cC8C wh18 pointer absolute top11 right12",
                      attrs: {
                        src:
                          _vm.$staticBaseUrl +
                          "assets/259cb717/547f3640/%E8%B7%AF%E5%BE%84%202.svg",
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }